import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyCHC0neWn-lGeXG-zVTJWPj1kcPrgwoTls',
  authDomain: 'sirius-7fd6a.firebaseapp.com',
  projectId: 'sirius-7fd6a',
  storageBucket: 'sirius-7fd6a.firebasestorage.app',
  messagingSenderId: '962744927723',
  appId: '1:962744927723:web:7d5fe1522d3b59a31385ae',
}

firebase.initializeApp(firebaseConfig)

const firebaseSideEffect = firebase.initializeApp(
  firebaseConfig,
  'Side Effect instance'
)

const db = firebase.firestore()
const storageRef = firebase.storage().ref()
const { storage } = firebase
const functions = firebase.app().functions('europe-west3')

export { db, storage, storageRef, firebase, firebaseSideEffect, functions }
